import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IAppSlice, IAppSliceConfig } from '../../../types/storeTypes';
import { AppDispatch } from '../..';
import { pollWindowVariables } from '../../../utils';

const app = createSlice({
  name: 'app',
  initialState: {
    initialized: false,
    loading: true,
    config: {
      currency: null,
      localeId: '',
      siteId: '',
      uplayData: {
        ready: true,
        authenticated: false
      }
    }
  } as IAppSlice,
  reducers: {
    setupStarted(state) {
      state.loading = true;
    },
    setupApp(state, action: PayloadAction<IAppSliceConfig>) {
      state.config = action.payload;
      state.loading = false;
      state.initialized = true;
    },
    startLoading(state) {
      state.loading = true;
    },
    endLoading(state) {
      state.loading = false;
    }
  }
});

export const { setupStarted, setupApp, startLoading, endLoading } = app.actions;

export default app.reducer;

export const fetchAppSetup = () => async (
    dispatch: AppDispatch
) => {
  try {
    dispatch(setupStarted());
    const windowVariablesPromises = await pollWindowVariables([
      'uplayData',
      'GeoRestrictedResources',
      'Constants',
      'anywhereAvailability'
    ]);

    const promiseValues = await Promise.all(windowVariablesPromises);
    const config: IAppSliceConfig = {
      currency: (promiseValues[1] as any).STOREFRONT_CURRENCY_CODE,
      localeId: (promiseValues[1] as any).STOREFRONT_CURRENT_LOCALE,
      siteId: (promiseValues[2] as any).SITE_ID,
      uplayData: {
        ready: true,
        ...(promiseValues[0] as object)
      }
    };

    await dispatch(setupApp(config));
  } catch (error) {
    console.log('App Setup Error: ', error);
  }
};
